import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { clearCart } = useApp();
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const [orderId, setOrderId] = useState(null);
  const attempts = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    const sessionId = sp.get("session_id");
    if (!sessionId) { setStatus("failed"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setOrderId(data.order_id);
        if (data.payment_status === "paid") {
          if (!cleared.current) { clearCart(); cleared.current = true; }
          setStatus("paid");
          setTimeout(() => nav(`/order-confirmation/${data.order_id}`), 1600);
          return;
        }
        if (["failed", "expired"].includes(data.payment_status) || attempts.current > 12) { setStatus("failed"); return; }
      } catch { if (attempts.current > 12) { setStatus("failed"); return; } }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center" data-testid="payment-success-page">
      {status === "checking" && (<><Loader2 className="w-12 h-12 animate-spin text-forest mx-auto mb-4" /><h1 className="font-heading text-3xl text-forest">Confirming your payment…</h1><p className="text-brown/70 mt-2">Please wait, do not close this window.</p></>)}
      {status === "paid" && (<><CheckCircle2 className="w-14 h-14 text-earth mx-auto mb-4" /><h1 className="font-heading text-3xl text-forest">Payment Successful!</h1><p className="text-brown/70 mt-2">Redirecting to your order…</p></>)}
      {status === "failed" && (<><XCircle className="w-14 h-14 text-terracotta mx-auto mb-4" /><h1 className="font-heading text-3xl text-forest">Payment not confirmed</h1><p className="text-brown/70 mt-2">If money was deducted it will be auto-refunded. You can retry from your cart.</p>{orderId ? <Link to={`/order-confirmation/${orderId}`}><Button className="mt-5 rounded-full bg-forest text-cream">View Order</Button></Link> : <Link to="/cart"><Button className="mt-5 rounded-full bg-forest text-cream">Back to Cart</Button></Link>}</>)}
    </div>
  );
}
